import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const UserJournalSkeleton = () => {
  return (
    <div className="user-journal-skeleton" style={{ width: '100%', marginTop: 8 }}>
      {/* Header: Title + Add User Button + Debounced Search */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <Skeleton.Input active style={{ width: 220, height: 28, borderRadius: 4 }} />
        <Space size="middle">
          <Skeleton.Button active style={{ width: 170, height: 38, borderRadius: 6 }} />
          <Skeleton.Input active style={{ width: 220, height: 38, borderRadius: 6 }} />
        </Space>
      </div>

      {/* Users Table */}
      <Card
        bordered={false}
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          overflow: 'hidden',
          background: '#ffffff',
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Table Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #eaedf1',
            padding: '12px 18px',
            gap: 12,
          }}
        >
          <div style={{ width: '6%' }}><Skeleton.Input active size="small" style={{ width: 24, height: 14 }} /></div>
          <div style={{ width: '22%' }}><Skeleton.Input active size="small" style={{ width: '70%', height: 14 }} /></div>
          <div style={{ width: '20%' }}><Skeleton.Input active size="small" style={{ width: '60%', height: 14 }} /></div>
          <div style={{ width: '18%' }}><Skeleton.Input active size="small" style={{ width: '65%', height: 14 }} /></div>
          <div style={{ width: '14%' }}><Skeleton.Input active size="small" style={{ width: '50%', height: 14 }} /></div>
          <div style={{ width: '10%' }}><Skeleton.Input active size="small" style={{ width: '50%', height: 14 }} /></div>
          <div style={{ width: '10%' }}><Skeleton.Input active size="small" style={{ width: '40%', height: 14 }} /></div>
        </div>

        {/* User Rows */}
        {Array.from({ length: 8 }).map((_, idx) => (
          <div
            key={'user_skel_' + idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '14px 18px',
              borderBottom: idx === 7 ? 'none' : '1px solid #f1f5f9',
              backgroundColor: idx % 2 === 1 ? '#fafbfc' : '#ffffff',
              gap: 12,
            }}
          >
            <div style={{ width: '6%' }}>
              <Skeleton.Input active size="small" style={{ width: 22, height: 14, borderRadius: 2 }} />
            </div>
            <div style={{ width: '22%', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Skeleton.Avatar active size={32} shape="circle" />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '70%' }}>
                <Skeleton.Input active size="small" style={{ width: '90%', height: 14, borderRadius: 3 }} />
                <Skeleton.Input active size="small" style={{ width: '60%', height: 11, borderRadius: 2 }} />
              </div>
            </div>
            <div style={{ width: '20%' }}>
              <Skeleton.Input active size="small" style={{ width: '80%', height: 14, borderRadius: 3 }} />
            </div>
            <div style={{ width: '18%' }}>
              <Skeleton.Button active size="small" style={{ width: 90, height: 22, borderRadius: 12 }} />
            </div>
            <div style={{ width: '14%' }}>
              <Skeleton.Input active size="small" style={{ width: '75%', height: 14, borderRadius: 3 }} />
            </div>
            <div style={{ width: '10%' }}>
              <Skeleton.Button active size="small" style={{ width: 70, height: 22, borderRadius: 10 }} />
            </div>
            <div style={{ width: '10%' }}>
              <Space size="small">
                <Skeleton.Button active size="small" shape="circle" style={{ width: 26, height: 26 }} />
                <Skeleton.Button active size="small" shape="circle" style={{ width: 26, height: 26 }} />
              </Space>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default UserJournalSkeleton;

